/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddFileInput
 */
export interface AddFileInput {
    /**
     * 
     * @type {string}
     * @memberof AddFileInput
     */
    uploadUUID: string;
}

/**
 * Check if a given object implements the AddFileInput interface.
 */
export function instanceOfAddFileInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "uploadUUID" in value;

    return isInstance;
}

export function AddFileInputFromJSON(json: any): AddFileInput {
    return AddFileInputFromJSONTyped(json, false);
}

export function AddFileInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddFileInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uploadUUID': json['uploadUUID'],
    };
}

export function AddFileInputToJSON(value?: AddFileInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uploadUUID': value.uploadUUID,
    };
}

